module.exports = __webpack_public_path__ + "media/images/front/review_star_02-4231f703de2a09208270b7c0f6630350.png";